import { useState, useEffect } from 'react';

// Custom hook pro zobrazení tooltipu
export const useTooltip = (element) => {
    const [show, setShow] = useState(false);

    const showTooltip = () => {
        setShow(true);
    };

    const hideTooltip = () => {
        setShow(false);
    };

    useEffect(() => {
        if (!element || !element.current) {
            return;
        }

        element.current.addEventListener('mouseenter', showTooltip);
        element.current.addEventListener('mouseleave', hideTooltip);

        return () => {
            element.current.removeEventListener('mouseenter', showTooltip);
            element.current.removeEventListener('mouseleave', hideTooltip);
        };
    }, []);

    return { show };
};
